import {
  call,
  put,
  takeLatest
} from "redux-saga/effects";
import { authorizedRequest } from "utils/api";
import { ToastSuccess, ToastError } from "components/Global/Toasts/Toasty";

import { initialState } from "../utils/helpers";

export const PROFILE_PASSWORD_RESET = "PROFILE_PASSWORD_RESET";

// REDUCER
export default function profileSettings(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PROFILE_PASSWORD_RESET:
      return {
        ...state
      };
    default:
      return state;
  }
}

// ACTION
export function profileResetPasswordRequest(payload) {
  return {
    type: PROFILE_PASSWORD_RESET,
    payload
  };
}

// SAGA's
function* profilePasswordResetSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(authorizedRequest, "/profileSettings/resetPassword", "POST", payload);
    if (response.success === true) {
      ToastSuccess(response.msg || "Password updated");
    } else {
      ToastError(response.msg || "Something went wrong, please try again");
    }
  } catch (e) {
    ToastError("Something went wrong, please try again");
  }
}

export function* profileSettingsSaga() {
  yield takeLatest(PROFILE_PASSWORD_RESET, profilePasswordResetSaga);
}
